import {useRive, Layout, Fit, Alignment} from '@rive-app/react-canvas';

interface Props {
  src: string;
  caption: string;
  [key: string]: any;
}

function BlogAnimation({src, caption, ...props}: Props) {
  const {rive, RiveComponent} = useRive({
    src: src,
    autoplay: false,
    // https://help.rive.app/runtimes/layout
    layout: new Layout({fit: Fit.Fill, alignment: Alignment.Center}),
  });

  return (
    <div className="flex w-full flex-col items-center">
      <span className="text-xs italic">{'Keep your mouse over to play'}</span>
      <div className="aspect-[7/5] w-full">
        <RiveComponent
          onMouseEnter={() => rive?.play()}
          onMouseLeave={() => rive?.pause()}
          {...props}
        />
      </div>
      <span className="text-sm italic">{caption}</span>
    </div>
  );
}

export default BlogAnimation;
